export default "__VITE_ASSET__Caa9iUTz__"